var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88215 2.589C10.3789 2.05075 10.6273 1.78163 10.8913 1.62465C11.5282 1.24587 12.3124 1.23409 12.9599 1.59358C13.2283 1.74256 13.4843 2.00411 13.9964 2.52721C14.5084 3.0503 14.7645 3.31185 14.9103 3.58598C15.2622 4.24744 15.2507 5.04856 14.8799 5.69917C14.7262 5.9688 14.4628 6.22255 13.9359 6.73004L7.66676 12.7682C6.66826 13.7299 6.16901 14.2108 5.54505 14.4545C4.92109 14.6982 4.23514 14.6803 2.86325 14.6444L2.67659 14.6395C2.25894 14.6286 2.05012 14.6232 1.92873 14.4854C1.80734 14.3476 1.82392 14.1349 1.85706 13.7095L1.87506 13.4785C1.96835 12.2811 2.01499 11.6824 2.24881 11.1442C2.48263 10.606 2.88596 10.169 3.69263 9.29503L9.88215 2.589Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 2.66406L13.8327 7.33073",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 14.6641L15.1663 14.6641",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.0175dc149bed54c4b127418b29e62756.svg";
export { ForwardRef as ReactComponent };